/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ReferencedProjectDTO
 */
export interface ReferencedProjectDTO  {
    /**
     * 
     * @type {number}
     * @memberof ReferencedProjectDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof ReferencedProjectDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ReferencedProjectDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedProjectDTO
     */
    nameSupplement?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedProjectDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedProjectDTO
     */
    oldId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ReferencedProjectDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferencedProjectDTO
     */
    topOrgas?: Array<string>;
}

/**
 * Check if a given object implements the ReferencedProjectDTO interface.
 */
export function instanceOfReferencedProjectDTO(value: object): value is ReferencedProjectDTO {
    return true;
}

export function ReferencedProjectDTOFromJSON(json: any): ReferencedProjectDTO {
    return ReferencedProjectDTOFromJSONTyped(json, false);
}

export function ReferencedProjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferencedProjectDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
                  'name': json['name'] == null ? undefined : json['name'],
                  'nameSupplement': json['nameSupplement'] == null ? undefined : json['nameSupplement'],
                  'note': json['note'] == null ? undefined : json['note'],
                  'oldId': json['oldId'] == null ? undefined : json['oldId'],
                'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
              'topOrgas': json['topOrgas'] == null ? undefined : json['topOrgas'],
    };
}

export function ReferencedProjectDTOToJSON(json: any): ReferencedProjectDTO {
    return ReferencedProjectDTOToJSONTyped(json, false);
}

export function ReferencedProjectDTOToJSONTyped(value?: ReferencedProjectDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'endDate': value['endDate']?.toISOString(),
        'name': value['name'],
        'nameSupplement': value['nameSupplement'],
        'note': value['note'],
        'oldId': value['oldId'],
        'startDate': value['startDate']?.toISOString(),
        'topOrgas': value['topOrgas'] == null? value['topOrgas']: value['topOrgas'],
    };
}


